export const CVReview_1004 = [
	'overview',
	'subject',
	'neighborhood',
	'improvements',
	'comps',
	'salesapproach',
	'costapproach',
	'incomeapproach',
	'reconciliation',
	'pdfreview',
	'photoreview'
];
